import React, { useState } from 'react';
import { SectionHeader } from '../../../FirmSettings/components/SectionHeader/SectionHeader';
import { MarginProps } from '../../../../../theme/styledProps';
import { SignaturePageContent } from '../../../../../ManageSignaturePageModal/ManageSignaturePageModal.meta';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Button } from '../../../../../CommonComponents/OPL/Button/Button';
import { ManageSignaturePageModal } from '../../../../../ManageSignaturePageModal/ManageSignaturePageModal';

interface Props extends MarginProps {
  allowSignaturePageFirm: boolean;
  signaturePage: SignaturePageContent;
  canEditTitleAndBody: boolean;
  onChange?(change: { content: SignaturePageContent }): void;
}

export const SignaturePage = ({
  allowSignaturePageFirm,
  signaturePage,
  canEditTitleAndBody,
  onChange,
  ...rest
}: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (!allowSignaturePageFirm) {
    return null;
  }

  return (
    <>
      <Box as="section" {...rest}>
        <SectionHeader title="Signature Page" />

        <Button variant="link" onClick={() => setIsModalOpen(true)}>
          Manage Signature Page
        </Button>
      </Box>

      {isModalOpen && (
        <ManageSignaturePageModal
          isOpen={isModalOpen}
          mode="adviser"
          content={signaturePage}
          canEditTitleAndBody={canEditTitleAndBody}
          onClose={() => setIsModalOpen(false)}
          onChange={change => onChange?.(change)}
        />
      )}
    </>
  );
};
